import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from 'moment'

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontWeight: 'normal',
    fontSize: "12px",
    lineHeight: "16px",
    color: "#141414",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
    minWidth: "120px"
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  },
  even: {
    background: "#F3F3F3",
  },
  odd: {
    background: "#FFFFFF",
  },
  status: {
    boxSizing: "border-box",
    fontFamily: "Open Sans",
    fontSize: "13px",
    lineHeight: "18px",
    textAlign: "center",
    color: "#141414",
    borderRadius: "30px",
    textTransform: "capitalize",
    margin: "10px",
    padding: "6px",
    width: "80%",
  },
}));

function MediaTable(props) {
  const classes = useStyles();
  useTheme();

  const getClass = (rowIndex) => {
    if (rowIndex % 2 === 0) {
      return classes.even;
    }

    return classes.odd;
  };

  const extractDomainFromUrl = (url) => {
    if (!url) return "-";
    
    try {
      const protocolIndex = url.indexOf('//');
      if (protocolIndex === -1) return "-";
      
      const domainStart = protocolIndex + 2;
      const pathIndex = url.indexOf('/', domainStart);
      
      if (pathIndex === -1) {
        return url.substring(domainStart);
      } else {
        return url.substring(domainStart, pathIndex);
      }
    } catch (error) {
      return "-";
    }
  };

  const getEnvolvement = (envolvement) => {

    const Badge = ({ backgroundColor, textColor, text }) => (
      <div style={{backgroundColor: backgroundColor, borderRadius: "8px", color: textColor, padding: '4px 8px', fontWeight: 'bold'}} className={classes.status}>
        <span>{text}</span>
      </div>
    )

    switch (envolvement) {
      case "involved":
        return <Badge backgroundColor="#ff828255" textColor="#a60505" text="Envolvido" />
      case "investigated":
        return <Badge backgroundColor="#ff828255" textColor="#a60505" text="Investigado" />
      case "cited":
        return <Badge backgroundColor="#ffe5a899" textColor="#db9a00" text="Citado" />
      case "accused":
        return <Badge backgroundColor="#ff828255" textColor="#a60505" text="Denunciado" />
      case "summoned":
        return <Badge backgroundColor="#ff828255" textColor="#a60505" text="Intimado" />
      case "defendant":
        return <Badge backgroundColor="#ff828255" textColor="#a60505" text="Réu" />
      case "fined":
        return <Badge backgroundColor="#ff828255" textColor="#a60505" text="Multado" />
      case "indicted":
        return <Badge backgroundColor="#ff828255" textColor="#a60505" text="Indiciado" />
      case "delator":
        return <Badge backgroundColor="#ff828255" textColor="#a60505" text="Delator" />
      case "condemned":
        return <Badge backgroundColor="#ff828255" textColor="#a60505" text="Condenado" />
      case "arrested":
        return <Badge backgroundColor="#ff828255" textColor="#a60505" text="Preso" />
      case "revoked":
        return <Badge backgroundColor="#ff828255" textColor="#a60505" text="Cassado" />
      case "acquitted":
        return <Badge backgroundColor="#ff828255" textColor="#a60505" text="Absolvido" />
      default:
        return <Badge backgroundColor="#ffe5a899" textColor="#db9a00" text="Indisponível" />
    }
  }
  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: "8px" }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>Data de publicação</TableCell>
            <TableCell className={classes.tableHeader}>Título da notícia</TableCell>
            <TableCell className={classes.tableHeader}>Fonte</TableCell>
            <TableCell className={classes.tableHeader}>Link</TableCell>
            <TableCell className={classes.tableHeader}>Envolvimento</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.news.map((exposure, index) => (
            <TableRow
              key={index}
              className={getClass(index)}
            >
              <TableCell className={classes.tableText}>
                {exposure.date == null ? "-" : moment(exposure.date).format('DD/MM/YYYY')}
              </TableCell>
              <TableCell className={classes.tableText}>
                "{exposure.title}"
              </TableCell>
              <TableCell className={classes.tableText}>
                {extractDomainFromUrl(exposure.url)}
              </TableCell>
              <TableCell className={classes.tableText}>
                <a
                  href={exposure.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Link
                </a>
              </TableCell>
              <TableCell className={classes.tableText}>
                {getEnvolvement(exposure.involvement)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default MediaTable;
